import {CHELAudio, getAudioList, setAudioList} from './CHELAudio';
import {
  getMixerMuteAt,
  getMixerSettingAt,
  getMixerMasterVolume,
  getMixerMasterMute,
  pushNullToAudioList
} from './logics/dataOps';

import type {HEL_AUDIO_TYPE_VIDEO, HEL_AUDIO_TYPE_VOICE, HelAudioTypeIndex} from './logics/const';

const defineNextAudioIndexFromAudioList = (): number => {
  const audioList = getAudioList();

  for (let index = 0; index < audioList.length; index++) {
    if (audioList[index] === null || audioList[index] === undefined) {
      return index;
    }
  }

  pushNullToAudioList();
  return getAudioList().length - 1;
};

Object.assign(globalThis, {
  /**
   * @remarks
   * オーディオ
   * C++側, heliodor.jsからも呼出される
   *
   * @param fileName
   * @param type
   * @param play
   * @param loop
   * @param volume
   */
  createAudio: (
    fileName: string,
    type: HelAudioTypeIndex,
    play: boolean,
    loop: boolean,
    volume: number
  ): number => {
    const index = defineNextAudioIndexFromAudioList();

    const helAudio = new CHELAudio(type, volume);

    setAudioList(helAudio, index);

    helAudio.load(fileName, play, loop);

    return index;
  },

  /**
   * @remarks
   * C++側, heliodor.jsからも呼出される
   *
   * @param index
   */
  releaseAudioIndex: (index: number) => {
    const audioList = getAudioList();
    if (audioList[index] === null) {
      return;
    }

    audioList[index]?.release();
    setAudioList(null, index);
  },

  /**
   * @remarks
   * C++側, heliodor.jsからも呼出される
   *
   * @param index
   * @param loop
   */
  playAudio: (index: number, loop: boolean) => {
    const audioList = getAudioList();
    if (audioList[index] === null) {
      return;
    }

    audioList[index]?.play(loop);
  },

  /**
   * @remarks
   * C++側, heliodor.jsからも呼出される
   *
   * @param index
   */
  stopAudio: (index: number) => {
    const audioList = getAudioList();
    if (audioList[index] === null) {
      return;
    }

    audioList[index]?.stop();
  },

  /**
   * @remarks
   * C++側, heliodor.jsからも呼出される
   *
   * @param index
   */
  isPlayAudio: (index: number): number => {
    const audioList = getAudioList();
    if (audioList[index] === null) {
      return 0;
    }

    return audioList[index]?.isPlay() || 0;
  },

  /**
   * @remarks
   * C++側, heliodor.jsからも呼出される
   *
   * @param index
   * @param realVolume
   */
  setAudioVolume: (index: number, realVolume: number) => {
    const audioList = getAudioList();
    if (audioList[index] === null) {
      return;
    }

    return audioList[index]?.setVolume(realVolume);
  },

  /**
   * @remarks
   * C++側, heliodor.jsからも呼出される
   *
   * @param type
   */
  hel_mixer_GetVolume: (type: HelAudioTypeIndex): number => {
    return parseFloat(getMixerSettingAt(type) as unknown as string);
  },

  /**
   * @remarks
   * C++側, heliodor.jsからも呼出される
   *
   * @param type
   */
  hel_mixer_IsMute: (type: typeof HEL_AUDIO_TYPE_VOICE | typeof HEL_AUDIO_TYPE_VIDEO): number => {
    return parseFloat(getMixerMuteAt(type) as unknown as string);
  },

  /**
   * @remarks
   * C++側から呼出される
   */
  hel_mixer_GetMasterVolume: () => {
    return parseFloat(getMixerMasterVolume() as unknown as string);
  },

  /**
   * @remarks
   * C++側から呼出される
   */
  hel_mixer_IsMasterMute: () => {
    return parseFloat(getMixerMasterMute() as unknown as string);
  }
});
